import type { ReactNode } from 'react'

type AuthLoginViewProps = {
  customerAreaLabel: string
  title: string
  subtitle: string
  authCard: ReactNode
}

export const AuthLoginView = ({
  customerAreaLabel,
  title,
  subtitle,
  authCard,
}: AuthLoginViewProps) => (
  <div className="mx-auto w-full max-w-[620px] space-y-3">
    <header className="space-y-1.5 text-center">
      <p className="text-xs font-semibold uppercase tracking-[0.16em] text-(--color-status-info)">
        {customerAreaLabel}
      </p>
      <h1 className="mx-auto max-w-[20ch] text-balance text-2xl font-semibold tracking-tight text-(--color-text-primary) sm:text-[1.9rem]">
        {title}
      </h1>
      <p className="mx-auto max-w-[64ch] text-xs leading-relaxed text-(--color-text-muted) sm:text-sm">
        {subtitle}
      </p>
    </header>
    {authCard}
  </div>
)
